import React from 'react';
import { Upload } from 'antd';
import IconMove from '@/assets/images/icons/icons-move.svg';
import IconTrash from '@/assets/images/icons/icons-trash-outlined.svg';
import IconTrashWhite from '@/assets/images/icons/icons-trash-outlined-white.svg';
import './index.scss';

const CustomerProfilePicture = ({ value, onChange }) => {
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handlePreview = async ({ file }) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    onChange(file);
  };

  return (
    <div className="customer-avatar-image">
      <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        onChange={handlePreview}
      >
        {value ? (
          <img src={value} alt="avatar" />
        ) : (
          <div className="upload">
            <span>Drag and drop image</span>
          </div>
        )}
      </Upload>
      <section>
        {!value && <img src={IconMove} className="icon icon-move" />}
        <img
          src={value ? IconTrashWhite : IconTrash}
          className="icon icon-remove pointer"
          onClick={() => onChange(null)}
        />
        {value && (
          <div className="avatar">
            <img src={value} alt="avatar" />
          </div>
        )}
      </section>
    </div>
  );
};

export default CustomerProfilePicture;
